import { render } from "./CardBig.vue?vue&type=template&id=130b8214&scoped=true"
import script from "./CardBig.vue?vue&type=script&lang=js"
export * from "./CardBig.vue?vue&type=script&lang=js"

import "./CardBig.vue?vue&type=style&index=0&id=130b8214&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130b8214"]])

export default __exports__